import { Injectable } from '@angular/core';
import { MEAPIService } from '../../services/api/me-api.service';
import { ResponseCode, BasicAsyncResponseSuccessHandler } from '../../services/api/me-api-response';
import { CreateSessionResponseBean, IDScanStatusRequest, IDScanValidateRequestBean, IDScanValidationResponse, IDScanVerifyRequest, IDScanVerifyResponse, Scope } from './id-scan-bean';
import { AsyncSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdScanService {

  public static readonly API_ID_SCAN_CREATE: string = MEAPIService.BASE_URL + '/customer/idScan/create';
  public static readonly API_ID_SCAN_VERIFY: string = MEAPIService.BASE_URL + '/customer/idScan/verify';
  public static readonly API_ID_SCAN_STATUS: string = MEAPIService.BASE_URL + '/customer/idScan/status';
  public static readonly API_ID_SCAN_POLL: string = MEAPIService.BASE_URL + '/customer/idScan/poll';

  constructor(
    private readonly srvApi: MEAPIService,
  ) { }

  public create(scope: Scope): Observable<CreateSessionResponseBean> {
    let ret = new AsyncSubject<CreateSessionResponseBean>();
    let handlers = [new BasicAsyncResponseSuccessHandler<CreateSessionResponseBean>(ret, ResponseCode.SUCCESS)];
    this.srvApi.Post(IdScanService.API_ID_SCAN_CREATE, { scope }, handlers);
    return ret.asObservable();
  }

  public verify(bean: IDScanVerifyRequest): Observable<boolean> {
    let ret = new AsyncSubject<boolean>();
    let handlers = [new BasicAsyncResponseSuccessHandler<boolean>(ret, ResponseCode.SUCCESS)];
    this.srvApi.Post(IdScanService.API_ID_SCAN_VERIFY, bean, handlers)
    return ret.asObservable();
  }

  public status(bean: IDScanStatusRequest): Observable<IDScanVerifyResponse> {
    let ret = new AsyncSubject<IDScanVerifyResponse>();
    let handlers = [new BasicAsyncResponseSuccessHandler<IDScanVerifyResponse>(ret, ResponseCode.SUCCESS)];
    this.srvApi.Post(IdScanService.API_ID_SCAN_STATUS, bean, handlers);
    return ret.asObservable();
  }

  public poll(bean: IDScanValidateRequestBean): Observable<IDScanValidationResponse> {
    let ret = new AsyncSubject<IDScanValidationResponse>();
    let handlers = [new BasicAsyncResponseSuccessHandler<IDScanValidationResponse>(ret, ResponseCode.SUCCESS)];
    this.srvApi.Post(IdScanService.API_ID_SCAN_POLL, bean, handlers);
    return ret.asObservable();
  }

}